import { useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";

const OutboundRedirect = () => {
  const location = useLocation();

  const url = useMemo(() => {
    const params = new URLSearchParams(location.search);
    const u = params.get("u") || "";
    return u;
  }, [location.search]);

  const isValid = url.startsWith("http://") || url.startsWith("https://");

  useEffect(() => {
    if (!isValid) return;

    // Small delay so the page can paint (and makes some browsers more willing to navigate).
    const t = window.setTimeout(() => {
      window.location.assign(url);
    }, 50);

    return () => window.clearTimeout(t);
  }, [isValid, url]);

  return (
    <main className="min-h-screen bg-background text-foreground">
      <div className="mx-auto flex max-w-xl flex-col items-center justify-center gap-4 px-6 py-16 text-center">
        <h1 className="text-2xl font-semibold">Weiterleitung zur Studie…</h1>
        {!isValid ? (
          <p className="text-muted-foreground">Ungültiger Link.</p>
        ) : (
          <p className="text-muted-foreground">
            Falls die Weiterleitung nicht automatisch startet, klicke unten.
          </p>
        )}

        {isValid && (
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className="underline underline-offset-4"
          >
            Studie öffnen
          </a>
        )}

        <Button asChild variant="outline">
          <a href="/research">Zurück zur Übersicht</a>
        </Button>
      </div>
    </main>
  );
};

export default OutboundRedirect;
